<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense>
        <p style="font-size: 30px; color:white;" class="mb-0">Atención de requerimiento</p>
      </v-col>
      <!-- Registro-->
      <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" v-if="filtros">
        <v-card mx-auto outlined>
          <v-row class="grey lighten-5">
            <v-col
              cols="12"
              md="12"
              sm="12"
              xs="12"
              lg="3"
              xl="3"
              class="mx-0 px-0"
            >
              <v-col
                cols="12"
                md="12"
                sm="12"
                xs="12"
                lg="12"
                xl="12"
                dense
                class="pt-0"
              >
                <v-list-item-title>Seleccionar Requerimiento</v-list-item-title>
                <v-autocomplete
                  v-model="requerimientosSeleccionados"
                  :items="lista_requerimientos"
                  :loading="loadingRequerimientos"
                  label="Requerimiento"
                  item-value="idrequerimiento"
                  item-text="denominacion"
                  dense
                  chips
                  multiple
                  @input="searchInputRequerimientos = ''"
                  :search-input.sync="searchInputRequerimientos"
                  @change="onRequerimientosChange"
                >
                  <!-- chips -->
                  <template v-slot:selection="data">
                    <v-chip
                      small
                      dense
                      class="mb-1 mt-1"
                      close
                      @click:close="quitarRequerimiento(data.item)"
                    >
                      <span>{{ data.item.denominacion }}</span>
                    </v-chip>
                  </template>

                  <!-- items -->
                  <template v-slot:item="data">
                    <v-list-item-content width="50px">
                      <v-list-item-title
                        v-html="data.item.denominacion"
                      />
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-card class="mx-auto">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Coincidencias</v-list-item-title>
                    <v-list-item-subtitle>
                      <small>Filtros:</small>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-card-text>
                  <v-row dense>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      lg="12"
                      xl="12"
                      dense
                      class="pt-0"
                    >
                    <v-checkbox
                        v-model="chktiposervicio"
                        hide-details
                        label="Filtrar por tipo de servicio"
                        class="mt-0 pt-0 mb-2 pb-2"
                      ></v-checkbox>
                      <v-autocomplete
                        v-model="tipos_servicio"
                        :items="rubro_tipo_s_f"
                        label="Tipo empresa"
                        item-value="id"
                        item-text="nombrecategoria"
                        :disabled="!chktiposervicio"
                        dense
                        chips
                        multiple
                        @input="searchInput = null"
                        :search-input.sync="searchInput"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="remove4(data.item)"
                          >
                            <span>{{ data.item.nombrecategoria }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-content width="50px">
                            <v-list-item-title
                              v-html="data.item.nombrecategoria"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      lg="12"
                      xl="12"
                      dense
                      class="pt-0"
                    >
                      <v-checkbox
                        v-model="chkcobertura"
                        hide-details
                        label="Filtrar por cobertura de servicio"
                        class="mt-0 pt-0 mb-2 pb-2"
                      ></v-checkbox>
                      <v-autocomplete
                        v-model="cobertura"
                        :items="lista_cobertura"
                        label="Tipo de cobertura"
                        item-value="value"
                        item-text="tipo"
                        :disabled="!chkcobertura"
                        dense
                        chips
                        multiple
                        @input="searchInput = null"
                        :search-input.sync="searchInput"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="remove5(data.item)"
                          >
                            <span>{{ data.item.tipo }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-content width="50px">
                            <v-list-item-title
                              v-html="data.item.tipo"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      lg="12"
                      xl="12"
                      dense
                      class="pt-0"
                    >
                      <v-checkbox
                        v-model="chkccategorizacion"
                        hide-details
                        label="Filtrar por Categorización del Proveedor"
                        class="mt-0 pt-0 mb-2 pb-2"
                      ></v-checkbox>
                      <v-autocomplete
                        v-model="categorizacion_proveedor"
                        :items="categorizacion"
                        :filter="customFilterCLocacion"
                        :disabled="!chkccategorizacion"
                        label="Categorización del Proveedor"
                        item-text="text"
                        item-value="value"
                        dense
                        chips
                        multiple
                        @input="searchInput = null"
                        :search-input.sync="searchInput"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="remove(data.item)"
                          >
                            <span>{{ data.item.text }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-content width="50px">
                            <v-list-item-title
                              v-html="data.item.text"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      lg="12"
                      xl="12"
                      dense
                      class="pt-0"
                    >
                      <v-checkbox
                        v-model="chkcccia"
                        hide-details
                        label="Filtrar por Status de Participación CCIA"
                        class="mt-0 pt-0 mb-2 pb-2"
                      ></v-checkbox>
                      <v-autocomplete
                        v-model="participacion_ccia"
                        :items="l_participacion_ccia"
                        :filter="customFilterCLocacion"
                        :disabled="!chkcccia"
                        label="Status de Participación CCIA"
                        item-text="text"
                        item-value="value"
                        dense
                        chips
                        multiple
                        @input="searchInput = null"
                        :search-input.sync="searchInput"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="remove2(data.item)"
                          >
                            <span>{{ data.item.text }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-content width="50px">
                            <v-list-item-title
                              v-html="data.item.text"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      lg="12"
                      xl="12"
                      dense
                      class="pt-0"
                    >
                      <v-checkbox
                        v-model="chkempresas"
                        hide-details
                        label="Filtrar por empresa"
                        class="mt-0 pt-0 mb-2 pb-2"
                      />

                      <v-autocomplete
                        v-model="empresasSeleccionadas"
                        :items="lista_empresas"
                        label="Empresas"
                        item-value="idempresa"
                        item-text="razonsocial"
                        :disabled="!chkempresas"
                        dense
                        chips
                        multiple
                        @input="searchInputEmpresas = null"
                        :search-input.sync="searchInputEmpresas"
                        @change="onEmpresasChange"
                      >
                        <!-- chips -->
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            dense
                            class="mb-1 mt-1"
                            close
                            @click:close="quitarEmpresa(data.item)"
                          >
                            <span>{{ data.item.razonsocial }}</span>
                          </v-chip>
                        </template>

                        <!-- items -->
                        <template v-slot:item="data">
                          <v-list-item-content width="50px">
                            <v-list-item-title
                              v-html="data.item.razonsocial"
                            />
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                      xs="12"
                      lg="12"
                      xl="12"
                      dense
                      class="pt-0"
                    >
                      <v-checkbox
                        v-model="chkCarta"
                        hide-details
                        label="Filtrar por carta de presentación"
                        class="mt-0 pt-0 mb-2 pb-2"
                      />

                      <v-text-field
                        v-model="filtroCarta"
                        label="Texto en carta de presentación"
                        dense
                        clearable
                        :disabled="!chkCarta"
                        placeholder="Ingrese texto a buscar"
                      />
                    </v-col>

                  </v-row>
                </v-card-text>
                <v-card-actions></v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="12" md="12" sm="12" xs="12" lg="9" xl="9">
              <v-card class="mx-auto">
                <v-row dense>
                  <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" class="d-flex justify-end">
                    <v-btn
                      class="ma-2"
                      color="primary"
                      @click="ListarPostulantes"
                    >
                      <v-icon left>mdi-filter-plus-outline</v-icon>Filtrar
                    </v-btn>

                    <v-btn
                      class="ma-2 white--text"
                      color="light-blue darken-4"
                      @click="handleDownload"
                    >
                      <v-icon left>mdi-folder-multiple-plus-outline</v-icon
                      >Exportar
                    </v-btn>

                    <v-btn
                      class="ma-2 white--text"
                      color="light-blue darken-4"
                      @click="postularMasivo"
                    >
                      <v-icon left>mdi-send</v-icon
                      >Postular
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12" xs="12" dense>
                      <v-data-table
                        :headers="headercontratosempresas"
                        :items="contratosempresas"
                        height="300px"
                        class="elevation-1"
                        item-key="idempresa"
                      >
                        <template v-slot:item="{ item }">
                          <tr
                            :class="isSelected(item) ? 'light-blue darken-4 white--text rounded-lg' : ''"
                            @click="rowClicked(item)"
                          >
                            <td class="text-sm-center"><small>{{ item.razonsocial }}</small></td>
                            <td class="text-sm-center"><small>{{ item.ruc }}</small></td>
                            <td class="text-sm-center"><small>{{ item.correo }}</small></td>
                            <td class="text-sm-center"><small>{{ item.NombreCategoria }}</small></td>
                            <td class="text-sm-center"><small>{{ item.carta_presentacion }}</small></td>
                            <td class="text-sm-center"><small>{{ item.diagnostico_ccia }}</small></td>
                            <td class="text-sm-center"><small>{{ item.resultado_final_localia }}</small></td>
                            <td class="text-sm-left"><small>{{ item.puntaje_total_localia }}</small></td>
                            <td class="text-sm-left"><small>{{ item.comentario }}</small></td>
                            <td class="text-sm-left"><small>{{ item.categoria_proveedor }}</small></td>
                          </tr>
                        </template>
                        <template v-slot:no-data>No existe contratos con los filtros seleccionados</template>
                        <template v-slot:no-results>NO RESULTS HERE!</template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions></v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-dialog v-model="dialogFiltros" max-width="800px">
        <v-card outlined class="pa-3">
          <span class="font-weight-bold">Completar información de coberturas</span>
          <v-divider class="my-2" />
          <v-card
            outlined
            class="ma-3 pa-3"
            v-if="cobertura.includes(11)">
            <span class="font-weight-bold primary--text">Cocina / Planta</span>

            <v-text-field v-model="cocinaplanta.direccioncocinaplanta" label="dirección de la cocina / planta" dense />

            <v-checkbox v-model="cocinaplanta.coberturacocachacra" label="cobertura cocachacra" />
            <v-checkbox v-model="cocinaplanta.coberturadeanvaldivia" label="cobertura deán valdivia" />
            <v-checkbox v-model="cocinaplanta.coberturapuntabombon" label="cobertura punta de bombón" />
            <v-checkbox v-model="cocinaplanta.coberturamejia" label="cobertura mejía" />
            <v-checkbox v-model="cocinaplanta.coberturamollendo" label="cobertura mollendo" />
            <v-text-field v-model="cocinaplanta.coberturaotros" label="otros" dense />

            <v-checkbox v-model="cocinaplanta.servicioraciones" label="raciones" />
            <v-checkbox v-model="cocinaplanta.serviciobuffet" label="buffet" />
            <v-checkbox v-model="cocinaplanta.serviciocafeteria" label="cafetería" />
            <v-checkbox v-model="cocinaplanta.serviciocatering" label="catering" />

            <v-text-field v-model.number="cocinaplanta.capacidaddiaria" label="capacidad diaria" type="number" dense />

            <v-switch v-model="cocinaplanta.certificadosanitariovigente" label="certificado sanitario vigente" />
            <v-switch v-model="cocinaplanta.vehiculosrefrigerados" label="vehículos refrigerados" />
            <v-switch v-model="cocinaplanta.capacidadinstalarcomedor" label="instalar comedor en campo" />

            <v-text-field v-model.number="cocinaplanta.propuestaeconomica" label="propuesta económica (s/.)" type="number" dense />
          </v-card>

          <v-card
            outlined
            class="ma-3 pa-3"
            v-if="cobertura.includes(10)">
            <span class="font-weight-bold primary--text">Hospedaje</span>

            <v-text-field v-model.number="hospedaje.habitacionesindividuales" label="habitaciones individuales" type="number" dense />
            <v-text-field v-model.number="hospedaje.habitacionesdobles" label="habitaciones dobles" type="number" dense />
            <v-text-field v-model.number="hospedaje.habitacionesmultiples" label="habitaciones múltiples" type="number" dense />

            <v-text-field v-model.number="hospedaje.capacidadtotalcamas" label="capacidad total camas" type="number" dense />

            <v-checkbox v-model="hospedaje.serviciodesayuno" label="desayuno" />
            <v-checkbox v-model="hospedaje.serviciowifi" label="wifi" />
            <v-checkbox v-model="hospedaje.serviciolavanderia" label="lavandería" />
            <v-checkbox v-model="hospedaje.servicioestacionamiento" label="estacionamiento" />
            <v-checkbox v-model="hospedaje.servicioaguacaliente" label="agua caliente" />

            <v-switch v-model="hospedaje.certificadoitsevigente" label="certificado itse vigente" />

            <v-text-field v-model.number="hospedaje.tarifacorporativareferencial" label="tarifa corporativa (s/.)" type="number" dense />
          </v-card>

          <v-card
            outlined
            class="ma-3 pa-3"
            v-if="cobertura.includes(1)">
            <span class="font-weight-bold primary--text">Garaje / Base de operaciones</span>

            <v-text-field v-model="garaje.direcciongarajebase" label="dirección" dense />
            <v-checkbox v-model="garaje.coberturacocachacra" label="cocachacra" />
            <v-checkbox v-model="garaje.coberturadeanvaldivia" label="deán valdivia" />
            <v-checkbox v-model="garaje.coberturapuntabombon" label="punta de bombón" />
            <v-checkbox v-model="garaje.coberturamejia" label="mejía" />
            <v-checkbox v-model="garaje.coberturamollendo" label="mollendo" />
            <v-checkbox v-model="garaje.cob_rutas_regionales" label="rutas regionales" />
            <v-text-field v-model="garaje.coberturaotros" label="otros" dense />
          </v-card>

          <v-col
            cols="12"
            v-if="cobertura.includes(1)"
          >
            <v-card outlined class="ma-3 pa-3">
              <span class="font-weight-bold primary--text">
                Flota vehicular
              </span>

              <v-divider class="my-2" />

              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    v-model="flota.tipounidad"
                    label="Tipo de unidad"
                    dense
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="flota.placa"
                    label="Placa"
                    dense
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="flota.marca"
                    label="Marca"
                    dense
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="flota.modelo"
                    label="Modelo"
                    dense
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model.number="flota.anio"
                    label="Año"
                    type="number"
                    dense
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="flota.capacidad"
                    label="Capacidad"
                    dense
                  />
                </v-col>

                <v-col cols="4">
                  <v-switch
                    v-model="flota.soatpolizavigente"
                    label="SOAT vigente"
                  />
                </v-col>

                <v-col cols="4">
                  <v-switch
                    v-model="flota.gps"
                    label="GPS"
                  />
                </v-col>

                <v-col cols="4">
                  <v-switch
                    v-model="flota.cinturon3puntos"
                    label="Cinturón 3 puntos"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="flota.tarifareferencial"
                    label="Tarifa referencial"
                    dense
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <v-card
            outlined
            class="ma-3 pa-3"
            v-if="cobertura.includes(2)">
            <span class="font-weight-bold primary--text">Ubicación de equipo</span>

            <v-text-field v-model="ubicacionequipo.ubicacionequipogaraje" label="ubicación" dense />

            <v-checkbox v-model="ubicacionequipo.coberturacocachacra" label="cocachacra" />
            <v-checkbox v-model="ubicacionequipo.coberturadeanvaldivia" label="deán valdivia" />
            <v-checkbox v-model="ubicacionequipo.coberturapuntabombon" label="punta de bombón" />
            <v-checkbox v-model="ubicacionequipo.coberturamejia" label="mejía" />
            <v-checkbox v-model="ubicacionequipo.coberturamollendo" label="mollendo" />
            <v-text-field v-model="ubicacionequipo.coberturaotros" label="otros" dense />
          </v-card>

          <v-col
            cols="12"
            v-if="cobertura.includes(2)"
          >
            <v-card outlined class="ma-3 pa-3">
              <span class="font-weight-bold primary--text">
                Maquinaria
              </span>

              <v-divider class="my-2" />

              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    v-model="maquinaria.tipomaquinaria"
                    label="Tipo de maquinaria"
                    dense
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="maquinaria.marcamodelo"
                    label="Marca / Modelo"
                    dense
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model.number="maquinaria.anio"
                    label="Año"
                    type="number"
                    dense
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="maquinaria.capacidadtecnica"
                    label="Capacidad técnica (m³ / ton)"
                    dense
                  />
                </v-col>

                <v-col cols="4">
                  <v-switch
                    v-model="maquinaria.certificadosvigentes"
                    label="Certificados vigentes"
                  />
                </v-col>

                <v-col cols="4">
                  <v-switch
                    v-model="maquinaria.incluyeoperador"
                    label="Incluye operador"
                  />
                </v-col>

                <v-col cols="4">
                  <v-switch
                    v-model="maquinaria.incluyecombustible"
                    label="Incluye combustible"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="maquinaria.tipotarifa"
                    label="Tipo de tarifa"
                    dense
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="maquinaria.tarifareferencial"
                    label="Tarifa referencial (S/.)"
                    dense
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>


          <v-card
            outlined
            class="ma-3 pa-3"
            v-if="cobertura.includes(8)">
            <span class="font-weight-bold primary--text">Planta / Grifo</span>

            <v-text-field v-model="plantagrifo.direccionplantagrifo" label="dirección" dense />

            <v-checkbox v-model="plantagrifo.coberturacocachacra" label="cocachacra" />
            <v-checkbox v-model="plantagrifo.coberturadeanvaldivia" label="deán valdivia" />
            <v-checkbox v-model="plantagrifo.coberturapuntabombon" label="punta de bombón" />
            <v-checkbox v-model="plantagrifo.coberturamejia" label="mejía" />
            <v-checkbox v-model="plantagrifo.coberturamollendo" label="mollendo" />
            <v-text-field v-model="plantagrifo.coberturaotros" label="otros" dense />

            <v-checkbox v-model="plantagrifo.combustibledieselb5" label="diésel b5" />
            <v-checkbox v-model="plantagrifo.combustiblegasolina90" label="gasolina 90" />
            <v-checkbox v-model="plantagrifo.combustiblegasolina95" label="gasolina 95" />
            <v-checkbox v-model="plantagrifo.combustibleglp" label="glp" />

            <v-text-field v-model.number="plantagrifo.capacidadsuministrodiario" label="capacidad diaria (gal)" type="number" dense />
            <v-text-field v-model.number="plantagrifo.capacidadcisternas" label="capacidad cisterna (gal)" type="number" dense />

            <v-switch v-model="plantagrifo.permisososinergminvigentes" label="permisos osinergmin vigentes" />
            <v-text-field v-model.number="plantagrifo.tiempominimopreaviso" label="tiempo mínimo preaviso (horas)" type="number" dense />
            <v-text-field v-model.number="plantagrifo.tarifareferencial" label="tarifa referencial (s/.)" type="number" dense />
          </v-card>
          <v-divider class="my-2" />

          <v-card-actions class="justify-end">
            <v-btn text @click="dialogFiltros = false">
              Cancelar
            </v-btn>

            <v-btn color="primary" @click="guardarFiltros">
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Administracion -->
      <v-col cols="12" md="12" sm="12" xs="12" dense v-if="administracion">
        <v-card class="mx-auto" outlined>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="requerimiento_headers"
                :items="requerimiento_items"
                :search="searchrequerimiento2"
                sort-by="denominacion"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title class=".body-2"
                      >Requerimientos</v-toolbar-title
                    >
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchrequerimiento2"
                      append-icon="mdi-magnify"
                      label="Busqueda"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-toolbar>
                  <v-divider></v-divider>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="primary"
                    class="mr-5"
                    @click="editItemRequerimiento2(item)"
                    >mdi-square-edit-outline</v-icon
                  >
                </template>
                <template v-slot:no-data></template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!-- Alertas -->
      <v-col cols="12" md="12" sm="12" xs="12" dense v-if="alertas">
        <v-card class="mx-auto" outlined>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="requerimientoalerta_headers"
                :items="requerimientoalerta_items"
                :search="searchrequerimientoalerta"
                sort-by="denominacion"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title class=".body-2"
                      >Alertas - Requerimientos</v-toolbar-title
                    >
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchrequerimientoalerta"
                      append-icon="mdi-magnify"
                      label="Busqueda"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-toolbar>
                  <v-divider></v-divider>
                </template>
                <template v-slot:item.estadolocales="{ item }">
                  <v-chip
                    class="ma-2"
                    x-small
                    dark
                    :color="getcolorestado(item.fecha_finlocales)">
                    {{ item.estadolocales }}
                  </v-chip>
                </template>
                <template v-slot:item.estadoactores="{ item }">
                  <v-chip
                    class="ma-2"
                    x-small
                    dark
                    :color="getcolorestado(item.fecha_finactores)">
                    {{ item.estadoactores }}
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="primary"
                    class="mr-5"
                    @click="editItemRequerimiento2(item)"
                    >mdi-square-edit-outline</v-icon
                  >
                </template>
                <template v-slot:no-data></template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="color">
        <v-icon dark class="pr-5">{{ icon }}</v-icon>
        {{ error }}
        <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
//Importamos Axios
import axios from "axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
//funciones de los filtros
import 'vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from 'vue-range-component'
import FilenameOption from '../views/excel/components/FilenameOption'
import AutoWidthOption from '../views/excel/components/AutoWidthOption'
import BookTypeOption from '../views/excel/components/BookTypeOption'
import { parseTime } from '../utils'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
//Nuestro codigo Vue
export default {
  data: () => ({
    nuevo: true,
    nuevodetalle: false,
    registro: true,
    filtros: true,
    administracion: false,
    formatos: false,
    alertas: false,
    searchInput: null,
    rubro_tipo_servicio: "",
    rubro_tipo_s: [],
    rubro_tipo_s_f: [],
    id_areausuaria: "",
    cobertura: [],
    participacion_ccia: [],
    codigo_contrato: "",
    lista_detalles: [],
    lista_areas: [],
    contratosempresas: [],
    selectedRows: [],
    editedIndexDetalle: -1,
    requerimientofecha_convocatoria: "",
    loading: false,
    chkempresas: false,
    empresasSeleccionadas: [],
    lista_empresas: [], // viene de la API
    requerimientosSeleccionados: [],
    req_sel: [],
    listarequerimientos: [],
    searchInputEmpresas: null,
    searchInputRequerimientos: null,
    headerdetalles: [
      { text: "Cantidad", value: "cantidad", align: "start" },
      { text: "Detalle", value: "detalle", align: "start" },
      { text: "Actions", value: "actions", sortable: false, align: "end" },
    ],
    headercontratosempresas: [
      { text: "Empresa", value: "razonsocial", align: "start", width: "150px" },
      { text: "RUC", value: "ruc", align: "center" },
      { text: "Correo", value: "correo", align: "center" },
      { text: "Tipo de Servicio", value: "NombreCategoria", align: "center" },
      { text: "Carta de presentación", value: "carta_presentacion", align: "center" },
      { text: "Diagnóstico CCIA", value: "diagnostico_ccia", align: "center" },
      { text: "Resultado final de localía", value: "resultado_final_localia", align: "start" },
      { text: "Puntaje total de localía", value: "puntaje_total_localia", align: "start" },
      { text: "Comentario", value: "comentario", align: "start" },
      { text: "Categoría Proveedor", value: "categoria_proveedor", align: "center" },
    ],
    requerimiento_headers: [
      {
        text: "Denominación",
        align: "start",
        sortable: false,
        value: "denominacion",
      },
      { text: "Fecha inicio", value: "fecha_inicio" },
      { text: "Fecha fin", value: "fecha_fin" },
      { text: "Perfil", value: "perfil" },
      { text: "Tipo de postulante", value: "tipo_postulante" },
      { text: "Empresa", value: "empresa" },
      { text: "Area", value: "area" },
      { text: "Tipo de Educacion", value: "tipo_educacion" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    chktiposervicio: false,
    chktipolocacion: false,
    chkccategorizacion: false,
    chktrabajando: false,
    chkfechas: false,
    chkmonto: false,
    chkrubroempresa: false,
    chkcobertura: false,
    chkcccia: false,
    requerimiento_items: [],
    searchrequerimiento: "",
    tipos_servicio: [],
    search: "",
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    overlay2: false,
    model: [],
    snackbar: false,
    error: null,
    errorMessages: "",
    form1HasErrors: false,
    form2HasErrors: false,
    form3HasErrors: false,
    form4HasErrors: false,
    form5HasErrors: false,
    color: "#2A3B4D",
    icon: "mdi-thumb-up",
    dialogeducacion: false,
    dialogdetalle: false,
    dialogexperiencia: false,
    dialogconocimiento: false,
    menu2: false,
    menu3: false,
    /*Area y Empresa*/
    areas: [],
    empleados: [],
    empleadosFiltrados: [], 
    idempresa: "",
    idoperador: "",
    searchareas: "",
    empresa: "",
    listarequerimientos: [],
    listarequerimientos2: [],
    requerimientos: [],

    /* Requerimiento */
    searchrequerimiento2: "",
    editedIndexrequerimiento: -1,
    requerimientoid: "",
    requerimientoid2: "",
    //requerimientodenominacion: "",
    requerimiento_tipo: "",
    empresa_contratista: "",
    ruc_contratista: "",
    representante_contratista: "",
    celular_contratista: "",
    representante_sitio_contratista: "",
    celular_sitio_contratista: "",
    tiempo_contratacion: "",
    observaciones: "",
    elaborado_por: "",
    cargo_area: "",
    empresa_contacto: "",
    celular_contacto: "",
    fecha_solicitud: "",
    correo: "",
    cantidad: "",
    detalle: "",
    categorizacion_proveedor: [],
    loadingRequerimientos: false,
    categorizacion: [
      { text: "Categoría A: Proveedor Local Estratégico", value: "Categoría A: Proveedor Local Estratégico"},
      { text: "Categoría B: Proveedor Local Genuino", value: "Categoría B: Proveedor Local Genuino"},
      { text: "Categoría C: Proveedor Local en Desarrollo", value: "Categoría C: Proveedor Local en Desarrollo"},
      { text: "Categoría D: Proveedor Consorciado con Componente Local", value: "Categoría D: Proveedor Consorciado con Componente Local"},
      { text: "Categoría E: Proveedor Regional Registrado", value: "Categoría E: Proveedor Regional Registrado"},
      { text: "Categoría F: Proveedor Foráneo No Aplicable", value: "Categoría F: Proveedor Foráneo No Aplicable"},
    ],
    lista_cobertura: [
        { tipo: "Transporte", value: 1 },
        { tipo: "Maquinaria", value: 2 },
        { tipo: "Combustible", value: 8 },
        { tipo: "Alojamiento", value: 10 },
        { tipo: "Alimentacion", value: 11 },
    ],
    cocinaplanta: {
        direccioncocinaplanta: '',
        coberturacocachacra: false,
        coberturadeanvaldivia: false,
        coberturapuntabombon: false,
        coberturamejia: false,
        coberturamollendo: false,
        coberturaotros: '',
        servicioraciones: false,
        serviciobuffet: false,
        serviciocafeteria: false,
        serviciocatering: false,
        capacidaddiaria: null,
        certificadosanitariovigente: false,
        vehiculosrefrigerados: false,
        capacidadinstalarcomedor: false,
        propuestaeconomica: null
      },

      hospedaje: {
        habitacionesindividuales: null,
        habitacionesdobles: null,
        habitacionesmultiples: null,
        capacidadtotalcamas: null,
        serviciodesayuno: false,
        serviciowifi: false,
        serviciolavanderia: false,
        servicioestacionamiento: false,
        servicioaguacaliente: false,
        certificadoitsevigente: false,
        tarifacorporativareferencial: null
      },

      garaje: {
        direcciongarajebase: '',
        coberturacocachacra: false,
        coberturadeanvaldivia: false,
        coberturapuntabombon: false,
        coberturamejia: false,
        coberturamollendo: false,
        coberturaotros: '',
        fecharegistro: new Date().toISOString().slice(0, 10)
      },

      flota: {
        tipounidad: '',
        placa: '',
        marca: '',
        modelo: '',
        anio: null,
        capacidad: '',
        soatpolizavigente: false,
        gps: false,
        cinturon3puntos: false,
        tarifareferencial: null
      },

      lista_flota: [],

      headerFlota: [
        { text: 'tipo', value: 'tipounidad' },
        { text: 'placa', value: 'placa' },
        { text: 'marca', value: 'marca' },
        { text: 'año', value: 'anio' },
        { text: 'acciones', value: 'actions', sortable: false }
      ],
      indexFlotaEdit: null,

      ubicacionequipo: {
        ubicacionequipogaraje: '',
        coberturacocachacra: false,
        coberturadeanvaldivia: false,
        coberturapuntabombon: false,
        coberturamejia: false,
        coberturamollendo: false,
        coberturaotros: ''
      },

      maquinaria: {
        tipomaquinaria: '',
        marcamodelo: '',
        anio: null,
        capacidadtecnica: '',
        certificadosvigentes: false,
        incluyeoperador: false,
        incluyecombustible: false,
        tipotarifa: '',
        tarifareferencial: null
      },

      lista_maquinaria: [],

      headerMaquinaria: [
        { text: 'tipo', value: 'tipo' },
        { text: 'marca / modelo', value: 'marca_modelo' },
        { text: 'año', value: 'anio' },
        { text: 'capacidad', value: 'capacidad_tecnica' },
        { text: 'acciones', value: 'actions', sortable: false }
      ],

      indexMaquinariaEdit: null,

      plantagrifo: {
        direccionplantagrifo: '',
        coberturacocachacra: false,
        coberturadeanvaldivia: false,
        coberturapuntabombon: false,
        coberturamejia: false,
        coberturamollendo: false,
        coberturaotros: '',
        combustibledieselb5: false,
        combustiblegasolina90: false,
        combustiblegasolina95: false,
        combustibleglp: false,
        capacidadsuministrodiario: null,
        capacidadcisternas: null,
        permisososinergminvigentes: false,
        tiempominimopreaviso: null,
        tarifareferencial: null
      },
    coberturasSeleccionadas: [], // Aquí guardamos lo que el usuario seleccione
    dialogFiltros: false,
    l_participacion_ccia: [
        { text: "SI", value: true },
        { text: "NO", value: false },
      ],
    requerimiento_estado: "",
    requerimiento_estados: [
      { text: "Planificado", value: "PLANIFICADO" },
      { text: "Aprobado", value: "APROBADO" },
      { text: "Iniciado", value: "INICIADO" },
      { text: "En proceso", value: "EN PROCESO" },
      { text: "Cerrado", value: "CERRADO" },
      { text: "Liberado", value: "LIBERADO" },
    ],
    observaciones: "",
    chkCarta: false,
    filtroCarta: "",

    /*Soporte*/
    valida: 0,
    validamensaje: [],
  }),

  created() {
    this.idusuario = localStorage.getItem('idusuario')
    let me = this;
    me.listar();
    me.selectEmpleados();
    me.listarRequerimiento();
    me.selectRequerimiento();
    this.cargarCategorias();
    this.cargarAreasUsuaria();
    this.cargarEmpresas();
    this.cargarRequerimientos();
    // Add a request interceptor
    axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        me.overlay2 = true;
        return config;
      },
      function (error) {
        // Do something with request error
        me.overlay2 = false;
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        // Any status code that lie within the range of 2xx cause me function to trigger
        // Do something with response data
        me.overlay2 = false;
        return response;
      },
      function (error) {
        // Any status codes that falls outside the range of 2xx cause me function to trigger
        // Do something with response error
        return Promise.reject(error);
        me.overlay2 = false;
      }
    );
  },
  computed: {
    form1() {
      return {
        idempresa: this.idempresa,
        idoperador: this.idoperador,
      };
    },
    form2() {
      return {
        educaciondenominacion: this.educaciondenominacion,
      };
    },
    form3() {
      return {
        experienciapuesto: this.experienciapuesto,
      };
    },
    form4() {
      return {
        conocimientodenominacion: this.conocimientodenominacion,
      };
    },
  },
  methods: {
    crearJSONfinal(data){
      // console.log("Entra a crear el JSON final");
      // console.log(JSON.stringify(data));
      let me = this;
      let datafinal=[];
      //var ajson=JSON.stringify(json);
      data.forEach((item, index)=>{
      let obj;
      obj={
        denominacion:item.denominacion,
        fecha_convocatoria:item.fecha_convocatoria,
        fecha_iniciolocales:item.fecha_iniciolocales,
        fecha_finlocales:item.fecha_finlocales,
        fecha_inicioactores:item.fecha_inicioactores,
        fecha_finactores:item.fecha_finactores,
        estadolocales:me.getestado(item.fecha_finlocales),
        estadoactores:me.getestado(item.fecha_finactores)
      }
      datafinal.push(obj)
    });
    // console.log(JSON.stringify(datafinal));
    return datafinal;
    },
    async cargarCategorias() {
      try {
        const response = await axios.get("/api/CategoriaServicios/Listar");
        this.rubro_tipo_s = response.data;
        this.rubro_tipo_s_f = response.data;
        // console.log(this.rubro_tipo_s_f)
      } catch (error) {
        console.error("Error cargando categorías:", error);
      }
    },
    agregarDetalle() {
      const nuevo = {
        cantidad: this.cantidad,
        detalle: this.detalle
      };

      // MODO EDITAR
      if (this.editIndex > -1) {
        Object.assign(this.lista_detalles[this.editIndex], nuevo);
      } 
      // MODO AGREGAR
      else {
        this.lista_detalles.push(nuevo);
      }
      // this.lista_detalles.push({
      //   cantidad: this.cantidad,
      //   detalle: this.detalle
      // });
      this.dialogdetalle = false;
      // console.log(this.lista_detalles);
    },
    getestado(fechafin) {
      let respuesta = "";
      let hoy = new Date();
      //console.log("Entra a generar estado locales");
      if (this.isDate(fechafin)) {
        let fecha = new Date(fechafin + "T00:00:00");
        //console.log(this.mostrarFecha(hoy)+"-"+this.mostrarFecha(fecha))     
        if(this.mostrarFecha(hoy)==this.mostrarFecha(fecha))
        {
          respuesta="Urgente (0 días)";
        }
        else{
          if(Math.round(fecha - hoy) < 0){
            respuesta="No monitoreado";
          }
          else{
            let Difference_In_Time = Math.abs(fecha - hoy); 
            let Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24)); 
            if(Difference_In_Days== 1){
              respuesta="Urgente (1 día)";
            }
            if(Difference_In_Days== 2 ){
              respuesta="Alerta (2 días)";
            }
             if(Difference_In_Days== 3){
              respuesta="Alerta (3 días)";
            }
            if(Difference_In_Days>=4){
              respuesta="A tiempo (+ 4 días)"
            }
          //console.log("Diferencia "+Difference_In_Days);
          //respuesta = Math.round(Difference_In_Days);
          }
        }
      }
      return respuesta;
    },
    saveDetalle() {
      let me = this;
      // me.validar2();
      if (me.form2HasErrors == false) {
        // me.saveEducacionMatch();
        for (const item of me.lista_detalles) {
          if (me.editedIndexDetalle > -1) {
              let me = this;
              axios
                .put("/api/Detalles/Actualizar", {
                  iddetalles: item.iddetalles,
                  cantidad: item.cantidad,
                  detalle: item.detalle,
                  idrequerimiento: me.requerimientoid,
                })
                .then(function (response) {
                  me.color = "#2A3B4D";
                  me.icon = "mdi-thumb-up";
                  me.error = "Registro exitoso";
                  me.snackbar = true;
                  me.listarEducacion();
                  me.limpiarEducacion();
                  me.selectEducacionPrincipal();
                  me.dialogeducacion = false;
                })
                .catch(function (error) {
                  console.log(error.response);
                  if (error.response.status == 400) {
                    me.error = error.response.data.toString();
                  }
                  me.color = "#E53935";
                  me.icon = "mdi-alert";
                  me.overlay2 = false;
                  me.snackbar = true;
                });
            } else {
              let me = this;
              axios
                .post("/api/Detalles/Crear", {
                  cantidad: item.cantidad,
                  detalle: item.detalle,
                  idrequerimiento: me.requerimientoid,
                })
                .then(function (response) {
                  me.color = "#2A3B4D";
                  me.icon = "mdi-thumb-up";
                  me.error = "Registro exitoso";
                  me.snackbar = true;
                  me.selectEducacionPrincipal();
                  me.listarEducacion();
                  me.limpiarEducacion();
                  me.dialogeducacion = false;
                })
                .catch(function (error) {
                  console.log(error.response);
                  if (error.response.status == 400) {
                    me.error = error.response.data.toString();
                  }
                  me.color = "#E53935";
                  me.icon = "mdi-alert";
                  me.overlay2 = false;
                  me.snackbar = true;
                });
            }
          }
      }
    },

    editItemDetalle(item) {
      this.dialogdetalle = true;
      this.editIndex = this.lista_detalles.indexOf(item);
      this.cantidad = item.cantidad;
      this.detalle = item.detalle;
      this.editedIndexDetalle = 1;
    },
    deleteItemDetalle(item) {
      const index = this.lista_detalles.indexOf(item);
      if (index > -1) {
        this.lista_detalles.splice(index, 1);
      }
      let me = this;
      me.detalleid = item.detalleid;
      confirm("Esta seguro(a) que desea eliminar este item?") &&
        axios
          .delete("/api/Detalles/Eliminar/" + me.detalleid)
          .then(function (response) {
            //me.snackbar = true;
            me.editedIndexEducacion = -1;
            //me.e6 = 2;
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Eliminación exitosa";
            me.snackbar = true;

            me.listarDetalle();
          })
          .catch(function (error) {
            console.log(error.response);
          });
    },
    isDate(value) {
      switch (typeof value) {
        case "number":
          return true;
        case "string":
          return !isNaN(Date.parse(value));
        case "object":
          if (value instanceof Date) {
            return !isNaN(value.getTime());
          }
        default:
          return false;
      }
    },
    activaregistro() {
      this.registro = true;
      this.administracion = false;
      this.formatos = false;
      this.alertas = false;
    },
    activaadministracion() {
      this.registro = false;
      this.administracion = true;
      this.formatos = false;
      this.alertas = false;
    },
    validar1() {
      /*Validacion Forms */
      this.error = null;
      this.form1HasErrors = false;

      Object.keys(this.form1).forEach((f) => {
        if (!this.form1[f]) this.form1HasErrors = true;

        const ref = this.$refs[f];

        if (ref && typeof ref.validate === "function") {
          ref.validate(true);
        } else {
          console.warn(`El ref '${f}' no existe o no tiene validate()`);
        }
      });
    },
    validar2() {
      /*Validacion Forms */
      this.error = null;
      this.form2HasErrors = false;

      Object.keys(this.form2).forEach((f) => {
        if (!this.form2[f]) this.form2HasErrors = true;
        this.$refs[f].validate(true);
      });

      if (this.requerimientoid == null || this.requerimientoid == "") {
        this.error = "Debe selecionar un requerimiento previamente";
        this.snackbar = true;
        this.color = "#E53935";
        this.icon = "mdi-alert";
        this.form2HasErrors = true;
      }
    },
    validar3() {
      /*Validacion Forms */
      this.error = null;
      this.form3HasErrors = false;

      Object.keys(this.form3).forEach((f) => {
        if (!this.form3[f]) this.form3HasErrors = true;
        this.$refs[f].validate(true);
      });

      if (this.requerimientoid == null || this.requerimientoid == "") {
        this.error = "Debe selecionar un requerimiento previamente";
        this.snackbar = true;
        this.color = "#E53935";
        this.icon = "mdi-alert";
        this.form3HasErrors = true;
      }
    },
    validar4() {
      /*Validacion Forms */
      this.error = null;
      this.form4HasErrors = false;

      Object.keys(this.form4).forEach((f) => {
        if (!this.form4[f]) this.form4HasErrors = true;
        this.$refs[f].validate(true);
      });

      if (this.requerimientoid == null || this.requerimientoid == "") {
        this.error = "Debe selecionar un requerimiento previamente";
        this.snackbar = true;
        this.color = "#E53935";
        this.icon = "mdi-alert";
        this.form4HasErrors = true;
      }
    },
    editItemRequerimiento2(item) {
      this.overlay = true;
      this.requerimientoid = item.idrequerimiento;
      this.registro = true;
      this.administracion = false;
      this.editItem();
      this.overlay = false;
    },
    remove(item) {
      const index = this.categorizacion_proveedor.indexOf(item.value);
      if (index !== -1) {
        this.categorizacion_proveedor.splice(index, 1);
      }
    },
    remove2(item) {
      const index = this.participacion_ccia.indexOf(item.value);
      if (index !== -1) {
        this.participacion_ccia.splice(index, 1);
      }
    },
    remove5(item) {
      const index = this.cobertura.indexOf(item.value);
      if (index !== -1) {
        this.cobertura.splice(index, 1);
      }
    },
    abrirDialogDetalle() {
      this.dialogdetalle = true;
      this.limpiarDetalle();
    },
    listar() {
      let me = this;
      me.requerimiento_items=[];
      me.requerimientoalerta_items=[];
      // console.log(me.idusuario);
      axios
        .get("api/Requerimientos/Listar", {
          params: {
            idusuario: me.idusuario
          }
        })
        .then(function (response) {
          me.requerimiento_items = response.data;
          // console.log(response.data)
          me.requerimientoalerta_items = me.crearJSONfinal(response.data);
          // console.log(me.requerimientoalerta_items)
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    limpiar() {
      let me = this;
      me.idempresa = "";
      me.idoperador = ""
      me.experiencias = [];
      me.educaciones = [];
      me.conocimientos = [];
      me.beneficios = [];
      me.requerimientoid = "";
      me.requerimientoid2 = "";
      me.codigo_contrato = "";
      me.nuevo = true;
    },
    selectEmpleados() {
      let me = this;
      // console.log(me.empleados)
      var Array = [];
      axios
        .get("api/Empleados/SelectEmpleo")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.empleados.push({ text: x.empleado, value: x.idempleado, id_areausuaria: x.id_areausuaria });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    getEmpleado() {
      let me = this;
      axios
        .get("api/Empleados/Mostrar/" + me.idoperador.toString())
        .then((response) => {
          me.empleado = response.data;
          // console.log("Empleado" + me.idoperador);
          if (me.empleado.areausuaria) {
            this.id_areausuaria=me.empleado.id_areausuaria
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    /* Requerimiento*/
    limpiarRequerimiento() {
      this.requerimientofecha_inicio = "";
      this.requerimientofecha_fin = "";
      this.idarea = "";
      this.requerimientofunciones = "";
      this.requerimiento_tipo = "";
      this.requerimiento_estado = "";
      this.requerimientocantidad = "";
      this.requerimiento_motivo = "";
      this.observaciones = "";
      this.requerimientoedadminima = "";
      this.requerimientoaño = new Year().getFullYear();
      this.editedIndexrequerimiento = -1;
    },

    selectRequerimiento() {
      let me = this;
      var Array = [];
      me.listarequerimientos = [];
      axios.get(`api/Requerimientos/Select/${this.idusuario}`)
      // axios.get("api/Requerimientos/Select")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.listarequerimientos.push({
              text: x.denominacion,
              value: x.idrequerimiento,
            });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },
    onlyForCurrency($event) {
      // console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    selectRequerimiento2() {
      let me = this;
      var Array = [];
      me.listarequerimientos = [];
      axios
        .get("api/Requerimientos/Select")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.listarequerimientos2.push({
              text: x.denominacion,
              value: x.idrequerimiento,
            });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },

    listarRequerimiento() {
      let me = this;
      axios
        .get("api/Requerimientos/Listar", {
          params: {
            idusuario: me.idusuario
          }
        })
        .then((response) => {
          //OJO Cuando Devuelve [Objetct Object  es es normal si queremos leer el JSON debemos cambiar a debemos convertirlo a JSON]
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i]);
          }
          me.requerimientos = res;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    editItem() {
      let emp = this.empleados;
      let me = this;
      var Array = [];
      this.loading = true;
      axios
        .get("api/Requerimientos/Mostrar/" + me.requerimientoid)
        .then(function (response) {
          me.requerimientoid = response.data.idrequerimiento;
          me.observaciones = response.data.observaciones;
          me.id_areausuaria = response.data.id_areausuaria;
          me.empleadosFiltrados = emp.filter(
            e => e.value === response.data.idoperador
          );
          me.$nextTick(() => {
            me.idoperador = response.data.idoperador;
          });
          me.codigo_contrato = response.data.codigo_contrato,
          me.empresa_contratista = response.data.empresa_contratista,
          me.ruc_contratista = response.data.ruc_contratista,
          me.representante_contratista = response.data.representante_contratista,
          me.celular_contratista = response.data.celular_contratista,
          me.representante_sitio_contratista = response.data.representante_sitio_contratista,
          me.celular_sitio_contratista = response.data.celular_sitio_contratista,
          me.tiempo_contratacion = response.data.tiempo_contratacion,
          me.elaborado_por = response.data.elaborado_por,
          me.cargo_area = response.data.cargo_area,
          me.empresa_contacto = response.data.empresa_contacto,
          me.celular_contacto = response.data.celular_contacto,
          me.requerimientofecha_convocatoria = response.data.fecha_inicio.split('T')[0],
          me.correo = response.data.correo,
          me.rubro_tipo_servicio = response.data.rubro_tipo_servicio,
          me.fecha_solicitud = response.data.fecha_solicitud.split('T')[0],
          me.editedIndexRequerimiento = 1;
          me.nuevo = false;
          me.listarDetalle();
          me.editedIndexDetalle = 1;
          me.filtros = true;
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error);
        });
    },

    editItemRequerimiento(item) {
      this.requerimientoid = item.idrequerimiento;
      this.observaciones = item.observaciones;
      this.idoperador = item.idoperador,
      this.codigo_contrato = item.codigo_contrato,
      this.empresa_contratista = item.empresa_contratista,
      this.ruc_contratista = item.ruc_contratista,
      this.representante_contratista = item.representante_contratista,
      this.celular_contratista = item.celular_contratista,
      this.representante_sitio_contratista = item.representante_sitio_contratista,
      this.celular_sitio_contratista = item.celular_sitio_contratista,
      this.tiempo_contratacion = item.tiempo_contratacion,
      this.elaborado_por = item.elaborado_por,
      this.cargo_area = item.cargo_area,
      this.empresa_contacto = item.empresa_contacto,
      this.celular_contacto = item.celular_contacto,
      this.fecha_solicitud = item.fecha_solicitud,
      this.correo = item.correo,
      this.editedIndexRequerimiento = 1;
    },
    saveRequerimiento() {
      this.validar1();
      if (this.form1HasErrors == false) {
        if (this.editedIndexRequerimiento > -1) {
          this.actualizarRequerimiento();
        } else {
          this.crearRequerimiento();
        }
      }
    },
    isDate(value) {
      switch (typeof value) {
        case "number":
          return true;
        case "string":
          return !isNaN(Date.parse(value));
        case "object":
          if (value instanceof Date) {
            return !isNaN(value.getTime());
          }
        default:
          return false;
      }
    },
    mostrarFecha(fecha) {
      var day = ("0" + fecha.getDate()).slice(-2);
      var month = ("0" + (fecha.getMonth() + 1)).slice(-2);
      var today = fecha.getFullYear() + "-" + month + "-" + day;
      return today;
    },
    crearRequerimiento() {
      let me = this;
      confirm(
        "Esta seguro(a) que desea crear el requerimiento, una vez creado este no se podrá eliminar."
      ) &&
        axios
          .post("/api/Requerimientos/Crear", {
            denominacion: me.autodenominacion,
            observaciones: me.observaciones,
            idoperador: me.idoperador,
            codigo_contrato: me.codigo_contrato,
            empresa_contratista: me.empresa_contratista,
            ruc_contratista: me.ruc_contratista,
            representante_contratista: me.representante_contratista,
            celular_contratista: me.celular_contratista,
            representante_sitio_contratista: me.representante_sitio_contratista,
            celular_sitio_contratista: me.celular_sitio_contratista,
            tiempo_contratacion: me.tiempo_contratacion,
            elaborado_por: me.elaborado_por,
            cargo_area: me.cargo_area,
            empresa_contacto: me.empresa_contacto,
            celular_contacto: me.celular_contacto,
            fecha_solicitud: me.fecha_solicitud,
            correo: me.correo,
            rubro_tipo_servicio: me.rubro_tipo_servicio,
            id_areausuaria: me.id_areausuaria,
            fecha_inicio: me.requerimientofecha_convocatoria,
          })
          .then(function (response) {
            me.requerimientoid = Number(response.data);
            console.log("Requerimiento creado " + me.requerimientoid);
            me.editedIndexrequerimiento = 1;
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Registro exitoso";
            me.snackbar = true;
            // me.saveProgramacion();
            me.selectRequerimiento();
            me.saveDetalle();
            me.listar();
            me.nuevo = false;
          })
          .catch(function (error) {
            console.log(error.response);
            if (error.response.status == 400) {
              me.error = error.response.data.toString();
            }
            me.color = "#E53935";
            me.icon = "mdi-alert";
            me.overlay2 = false;
            me.snackbar = true;
          });
    },
    actualizarRequerimiento() {
      let me = this;
      axios
        .put("/api/Requerimientos/Actualizar", {
          idrequerimiento: me.requerimientoid,
          denominacion: me.autodenominacion,
          observaciones: me.observaciones,
          idoperador: me.idoperador,
          codigo_contrato: me.codigo_contrato,
          empresa_contratista: me.empresa_contratista,
          ruc_contratista: me.ruc_contratista,
          representante_contratista: me.representante_contratista,
          celular_contratista: me.celular_contratista,
          representante_sitio_contratista: me.representante_sitio_contratista,
          celular_sitio_contratista: me.celular_sitio_contratista,
          tiempo_contratacion: me.tiempo_contratacion,
          elaborado_por: me.elaborado_por,
          cargo_area: me.cargo_area,
          empresa_contacto: me.empresa_contacto,
          celular_contacto: me.celular_contacto,
          fecha_solicitud: me.fecha_solicitud,
          correo: me.correo,
          rubro_tipo_servicio: me.rubro_tipo_servicio,
          id_areausuaria: me.id_areausuaria,
          fecha_inicio: me.requerimientofecha_convocatoria,
        })
        .then(function (response) {
          me.editedIndexrequerimiento = 1;
          me.color = "#2A3B4D";
          me.icon = "mdi-thumb-up";
          me.error = "Registro exitoso";
          me.snackbar = true;
          me.selectRequerimiento();
          me.saveDetalle();
          me.listar();
          // me.traerFechaInicioEvaluacion();
          me.
          me.nuevo = false;
        })
        .catch(function (error) {
          console.log(error.response);
          if (error.response.status == 400) {
            me.error = error.response.data.toString();
          }
          me.color = "#E53935";
          me.icon = "mdi-alert";
          me.overlay2 = false;
          me.snackbar = true;
        });
    },
    /*Experiencia*/
    limpiarDetalle() {
      this.cantidad = "";
      this.detalle = "";
      this.editedIndexDetalle = -1;
    },
    listarDetalle() {
      let me = this;
      me.lista_detalles = [];
      axios
        .get(
          "api/Detalles/GetDetallesByRequerimiento/?idrequerimiento=" +
            valor
        )
        .then((response) => {
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i]);
          }
          me.lista_detalles = res;
          // console.log(me.lista_detalles)
          return response.data;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    validar() {
      this.valida = 0;
      this.validamensaje = [];
      //Interesante con este codigo digo si tengo almenos 1 objeto en el array
      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
    remove4(item) {
      const index = this.tipos_servicio.findIndex(
        x => x === item.id   // porque item-value="id"
      );

      if (index !== -1) {
        this.tipos_servicio.splice(index, 1);
      }
    },
    async cargarAreasUsuaria() {
      try {
        const response = await axios.get("/api/AreaUsuaria/Listar");
        this.lista_areas = response.data;
      } catch (error) {
        console.error("Error cargando areas:", error);
      }
    },
    filtrarEmpleadosPorArea(areaId) {
      // console.log(this.empleados);
      this.empleadosFiltrados = this.empleados.filter(
        e => e.id_areausuaria === areaId
      );
      // console.log(this.empleadosFiltrados)
    },
    ListarPostulantes() {
      let me = this;
      me.cuallistar = "NORMAL";
      const payload = {};

      if (me.cobertura.includes(11))
        payload.cocinaplanta = me.cocinaplanta;

      if (me.cobertura.includes(10))
        payload.hospedaje = me.hospedaje;

      if (me.cobertura.includes(1)) {
        payload.garaje = me.garaje;
        payload.flota = me.flota;
      }

      if (me.cobertura.includes(2)){
        payload.ubicacionequipo = me.ubicacionequipo;
        payload.maquinaria = me.maquinaria;
      }

      if (me.cobertura.includes(8))
        payload.plantagrifo = me.plantagrifo;
      axios
        .post("api/FiltrosContratos/ListarContratos", {
          // tipos_servicio: me.tipos_servicio.join(","),
          tipos_servicio: me.tipos_servicio.map(t => t.id).join(","),
          cobertura: me.cobertura.join(","),
          categorizacion_proveedor: me.categorizacion_proveedor.join(","),
          participacion_ccia: me.participacion_ccia.join(","),
          f_tipo_servicio: me.chktiposervicio,
          f_tipo_cobertura: me.chkcobertura,
          f_categorizacion: me.chkccategorizacion,
          f_ccia: me.chkcccia,
          f_empresas: me.chkempresas,
          // lista_empresas: me.empresasSeleccionadas.map(e => e.idempresa),
          lista_empresas: me.filtroEmpresas,
          f_carta: me.chkCarta,
          texto_carta: me.filtroCarta,
          ...payload
        })
        .then((response) => {
          //OJO Cuando Devuelve [Objetct Object  es es normal si queremos leer el JSON debemos cambiar a debemos convertirlo a JSON]
          var obj = response.data;
          me.contratosempresas = [];
          var res = [];
          for (var i in obj) {
            res.push(obj[i]);
          }
          me.contratosempresas = res;
          if (me.contratosempresas.length > 0) {
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error =
              "Búsqueda exitosa. Se encontraron " +
              me.contratosempresas.length +
              " posibles empresas.";
            me.snackbar = true;
          } else {
            me.color = "#2A3B4D";
            me.icon = "mdi-information";
            me.error =
              "Búsqueda exitosa. Lamentablemente no se encontraron empresas, pruebe cambiando los filtros de busqueda por favor.";
            me.snackbar = true;
          }
        })
        .catch(function (error) {
          console.log(error.response);
          if (error.response.status == 400) {
            me.error = error.response.data.toString();
          }
          me.color = "#E53935";
          me.icon = "mdi-alert";
          me.snackbar = true;
        });
    },
    rowClicked(item) {
      const id = item.idempresa
      const index = this.selectedRows.indexOf(id)

      if (index === -1) {
        // agregar si no estaba seleccionado
        this.selectedRows.push(id)
      } else {
        // quitar si ya estaba seleccionado
        this.selectedRows.splice(index, 1)
      }
    },
    // Verifica si la fila está seleccionada
    isSelected(item) {
      return this.selectedRows.includes(item.idempresa)
    },
    async handleDownload() {

      if (!this.selectedRows.length) {
        alert('No hay empresas seleccionados')
        return
      }
      const contratosSeleccionados = this.contratosempresas.filter(c =>
        this.selectedRows.includes(c.idempresa)
      );
      console.log(contratosSeleccionados);

      let payload = {
        empresa_contratista: this.empresa_contratista,
        ruc_contratista: this.ruc_contratista,
        elaborado_por: this.elaborado_por,
        celular_contacto: this.celular_contacto,
        correo: this.correo,
        fecha_solicitud: new Date().toISOString(),
        lista_detalles: this.lista_detalles,
        selectedRows: contratosSeleccionados
      };

      this.downloadLoading = true
      console.log(this.selectedRows)
      try {
        const response = await axios.post(
          '/api/FiltrosContratos/ExportarSeguimiento',
          payload,
          { responseType: 'blob' } // importante para descargar binario
        )

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        console.log(this.rubro_tipo_s)
        const rubro = this.rubro_tipo_s.find(
          r => r.id === this.rubro_tipo_servicio
        );
        console.log(rubro)
        const nombre = rubro ? rubro.nombrecategoria : '';
        console.log(nombre)
        const nombreArchivo =
          `${this.zfill(this.requerimientoid, 3)}_RRQ_` +
          `${this.empresa_contratista}_` +
          `${nombre}_` +
          `${this.fechaActual()}.xlsx`;
        link.setAttribute('download', nombreArchivo)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

      } catch (error) {
        console.error('Error al exportar Excel', error)
      } finally {
        this.downloadLoading = false
      }
    },
    async postularMasivo() {

      if (!this.selectedRows.length) {
        alert('No hay empresas seleccionadas')
        return
      }

      if (!this.requerimientosSeleccionados.length) {
        alert('Selecciona al menos un requerimiento')
        return
      }

      // 👇 SOLO IDs de empresas
      const empresas = this.contratosempresas
        .filter(c => this.selectedRows.includes(c.idempresa))
        .map(c => c.idempresa)

      const payload = {
        requerimientos: this.requerimientosSeleccionados,
        empresas: empresas
      }

      try {
        await axios.post('/api/PostulacionEmpresas/PostularMasivo', payload)

        alert('Postulación realizada correctamente')

        // limpiar selección
        this.selectedRows = []

      } catch (error) {
        console.error(error)
        alert('Error al postular')
      }
    },
    generarFechaInicio1() {
      if (this.isDate(this.requerimientofecha_convocatoria)) {
        var d = new Date(this.requerimientofecha_convocatoria + "T00:00:00");
        d.setDate(d.getDate() + 1);
        this.requerimientofecha_iniciolocales = this.mostrarFecha(d);
      }
    },
    generarFechaInicio2() {
      if (this.isDate(this.fecha_solicitud)) {
        var d = new Date(this.fecha_solicitud + "T00:00:00");
        d.setDate(d.getDate() + 1);
      }
    },
    customFilterCLocacion(item, queryText, itemText) {
      const textOne = item.clasificacion.toLowerCase();
      const textTwo = item.similares.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    abrirPopupCoberturas(valores) {
      if (!valores || valores.length === 0) {
          this.dialogFiltros = false
          return
        }

        this.dialogFiltros = true
    },
    guardarFiltros() {
      // Aquí envías todos los datos correspondientes a las coberturas seleccionadas
      const payload = {};
      if(this.cobertura.includes(11)) payload.cocinaplanta = this.cocinaplanta;
      if(this.cobertura.includes(10)) payload.hospedaje = this.hospedaje;
      if(this.cobertura.includes(1)) payload.garaje = this.garaje;
      if(this.cobertura.includes(2)) payload.ubicacionequipo = this.ubicacionequipo;
      if(this.cobertura.includes(8)) payload.plantagrifo = this.plantagrifo;
      if (this.cobertura.includes(2)) {payload.maquinaria = this.maquinaria};
      if (this.cobertura.includes(1)) {payload.flota = this.flota}

      console.log("Datos a guardar:", payload.garaje);
      this.dialogFiltros = false;
    },
    cargarEmpresas() {
      let me = this;
      me.lista_empresas=[];
      axios
        .get("api/Empresas/Listar")
        .then(function (response) {
          me.lista_empresas = response.data;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    onEmpresasChange() {
      this.filtroEmpresas = [...this.empresasSeleccionadas];

      console.log('Empresas seleccionadas:', this.filtroEmpresas);
    },
    quitarEmpresa(empresa) {
      this.empresasSeleccionadas = this.empresasSeleccionadas.filter(
        id => id !== empresa.idempresa
      );
      // const index = this.empresasSeleccionadas.findIndex(
      //   x => x === item.id   // porque item-value="id"
      // );

      // if (index !== -1) {
      //   this.empresasSeleccionadas.splice(index, 1);
      // }
    },
    cargarRequerimientos() {
      let me = this;
      me.loadingRequerimientos = true;
      me.lista_requerimientos=[];
      axios
        .get("api/Requerimientos/Listar", {
          params: {
            idusuario: me.idusuario
          }
        })
        .then(function (response) {
          me.lista_requerimientos = response.data;
          // console.log(response.data);
          // console.log("DATA:", response.data);
          me.lista_requerimientos = response.data;
        })
        .catch(function (error) {
          console.log(error.response);
        })
        .finally(function () {
          me.loadingRequerimientos = false; // 👈 apaga loader
        });
    },
    async onRequerimientosChange() {
      this.filtroRequerimientos = [...this.requerimientosSeleccionados];
      console.log('Requerimientos seleccionadas:', this.filtroRequerimientos[0]);
      const idReq = this.filtroRequerimientos[0];
      console.log(idReq);
      this.req_sel = this.lista_requerimientos.filter(
        r => r.idrequerimiento === idReq
      );
      console.log(this.rubro_tipo_s_f);
      this.chktiposervicio = true;
      const rubrosPermitidos = this.req_sel.map(r => r.rubro_tipo_servicio);

      this.tipos_servicio = this.rubro_tipo_s_f
        .filter(r => rubrosPermitidos.includes(r.id));
      console.log(this.tipos_servicio);
      this.chkCarta = true;
      this.requerimientoid = this.filtroRequerimientos[0];
      axios
        .get(
          "api/Detalles/GetDetallesByRequerimiento/?idrequerimiento=" +
            this.filtroRequerimientos[0]
        )
        .then((response) => {
          var res = [];
          res = response.data;
          this.filtroCarta = res
            .map(detalle => detalle.servicio)
            .join(' ');
          console.log(this.filtroCarta);
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    quitarRequerimiento(requerimiento) {
      this.requerimientosSeleccionados = this.requerimientosSeleccionados.filter(
        id => id !== requerimiento.idrequerimiento
      );
    },
    zfill(num, size) {
      return String(num).padStart(size, '0');
    },
    fechaActual() {
      const f = new Date();
      const dd = String(f.getDate()).padStart(2, '0');
      const mm = String(f.getMonth() + 1).padStart(2, '0');
      const yyyy = f.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    },
  },
  watch: {
    id_areausuaria(newVal) {
      if (this.loading) return;
      console.log("actualizo por watch")
      if (newVal) {
        this.filtrarEmpleadosPorArea(newVal);
      } else {
        this.empleadosFiltrados = [];
      }
    },
    cobertura(nuevo) {
      this.abrirPopupCoberturas(nuevo);
    },
    chkempresas(val) {
      if (!val) this.empresasSeleccionadas = [];
    }
  }
}
</script>
<style scoped>
* {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 300;
}
.my-input {
  text-transform: uppercase;
}
table,
th,
td {
  border: 1px solid #eceff1;
  border-collapse: collapse;
}
th,
td {
  padding: 5px;
  text-align: left;
}
</style>